export default {
  translation: {
    app_title: "قندیل بلباس",
    home1: "للتجارة العامة المحدودة",
    home2: "للتجارة العامة المحدودة",
    home3: "للتجارة العامة المحدودة",
    home4: "للتجارة العامة المحدودة",
    home: "الرئسية",
    about: "من نحن",
    services: "خدماتنا",
    partners: "شركاء",
    sanaPanel: "الحیات بنل",
    powerPanel: "القوة بنل",
    power: "القوة",
    blackPipe: "بلاك بايب",
    qandelBrc: "القنديل BRC ",
    alSmood: "الصمود",
    products: "منتجاتنا",
    contact: "اتصل",
    about_us:"من نحن",
    core:"قدراتنا الجوهرية وشراكاتنا",
    targetp:"رؤيتنا هي أن نصبح شريكاً إقليمياً ودولياً موثوقاً به في دعم النمو الحضري، وتطوير البنية التحتية، والتوسع الصناعي.",
    target1p:"نلتزم ببناء شراكات طويلة الأمد مع عملائنا من خلال تقديم جودة مضمونة، وأسعار تنافسية، وحلول عملية مصممة خصيصاً لتلبية الاحتياجات المحددة لكل مشروع.",
    objectiv:"أهدافنا:",
    ob1:"التوسع الاستراتيجي: زيادة حصتنا السوقية من خلال الاستفادة من شبكات الموردين الحالية في تركيا ومصر والإمارات والصين، لتقديم خطوط إنتاج جديدة تلبي احتياجات السوق المحلية.",
    ob2:"الابتكار في الإنشاءات: الريادة في استخدام ألواح (PIR Sandwich Panels) والمقاطع الفولاذية المتقدمة لتقليص الجداول الزمنية للمشاريع وتحسين كفاءة العزل الحراري في البنية التحتية بالعراق.",
    ob3:"التميز العملياتي: دمج تقنيات التنفيذ السريع مع ممارسات البناء المستدامة، مع الالتزام التام بمعايير السلامة الصارمة لدينا.",
    about_p: `منذ تأسيس شركتنا في أربيل عام ٢٠١٠، رسّخت مكانتها كشركة رائدة في مجال التجارة العامة والمقاولات، متخصصة في الحديد ومواد البناء والمواد الكيميائية الصناعية وحلول توريد البنية التحتية. وبفضل سنوات من الخبرة والأداء المتميز، أصبحنا شريكًا موثوقًا به لمشاريع القطاعين العام والخاص.
نمتلك شبكة توريد دولية متينة مع كبرى الشركات المصنعة والموردة في تركيا ومصر والإمارات العربية المتحدة والصين وغيرها من الأسواق العالمية. تُمكّننا هذه العلاقات من تزويد عملائنا بمنتجات عالية الجودة تُلبي المعايير الدولية بأسعار تنافسية، مع ضمان التسليم الموثوق وفي الوقت المحدد.
`,
    pf:"تقدم شركتنا مجموعة شاملة من المواد، تشمل:",
    pf1:"مواد الحديد والتسليح",
    pf2:"قطاعات الصلب الإنشائي",
    pf3:"شبكات الأسلاك الملحومة",
    pf4:"مواد البناء والتشييد الأساسية",
    pf5:"المواد الكيميائية الصناعية المستخدمة في البنية التحتية والنفط والغاز ومختلف القطاعات الصناعية ",
    pf6:"كما نتعامل مع شركات النفط ونقدم خدمات النقل والتأمين. ",
    aboutp1:"إلى جانب التجارة، نقدم خدمات المقاولات التي تشمل التوريد وتنفيذ المشاريع، لضمان تسليم كل مشروع وفقًا لأعلى معايير الجودة والكفاءة والسلامة.",
    aboutp2:"نحن مرخصون أيضاً لمزاولة الأعمال في الولايات المتحدة الأمريكية ومعها، ونسعى جاهدين لإقامة شراكات استراتيجية مع الشركات الأمريكية، مما يُمكّننا من توسيع قدراتنا في مجال التوريد، والوصول إلى أحدث التقنيات، وتعزيز التعاون الدولي في قطاعي البناء والتنمية الصناعية.",
    why_chose_us: "لماذا نحن ؟",
    reason1: "محل الثقة السوق بنا.",
    reason2:"السرعة فى تلبية طلباتكم.",
    reason3:"خبرة تزيد عن 20 عامًا.",
    contact_form: "اتصل",
    name: "اسم",
    email: "البريد الإلكتروني",
    message: "رسالة",
    send_message: "إرسال رسالة",
    contact_p:
      "An Iraqi delivery company. Our goal is to give the best model for delivery companies by employing expertise and using the latest internationally approved technology.",
    address: "عنوان",
    address_value: `العراق، أربيل، شارع روناكي، مقابل مشفى ويست اي للعيون، عمارة سيد طيب البقال ،طابق السابع`,
    phone: "هاتف",
    copy_right: "© جميع الحقوق محفوظة لشريكة قندەل بلباس",
    page_not_found: "Page Not Found",
    is_required: "مطلوب!",
    not_valid: "ليس بريدًا إلكترونيًا صالحًا!",
    service1: "خط تقطيع ",
    service1_p:
      "لتقطيع رولات و تحويلها الى بنادل (ربطات) حسب طلبات ، و لکافة انواع الحديد المغلون ، الملون ، رول اسود بارد ، رول اسود حار.",
    service1_li1: "عرض الرول: من 40سم و لغاية 150سم",
    service1_li2: "سماكة الرول: من 0.20 ملم الى 2.00 ملم",
    service1_li3: "طول التقطيع : من 125سم الى 700 سم",
    service2: "خط الكيربي ( جملون السقف )",
    service2_p:
      "لانتاج الواح الکيربي (جملون السقف ) لسقوف الابنية و المخازن و الساحات.",
    service2_li1: "عرض الرول المستخدم : 120سم ، 122سم ، 125سم .",
    service2_li2: "عرض المنتج : 100سم (صافي )",
    service2_li3: "سماكة بليت : من 0.20 الى 0.90 ملم",
    service2_li4: "طول الکيربي : من 125سم الى 1700 سم",
    service3: "شفرات المنشار البارد",
    service3_p:
      "شفرات المنشار البارد لتوريد  , واشحاذ وتصليح شفرات المنشار البارد",
    service4: "الصناعة النفطية",
    service4_p: `تقدم Setup Venture أفضل الخدمات اللوجستية والتقنية للمشاريع النفطية. نضمن كفاءة وسلامة عملياتكم من خلال الالتزام التام بالمعايير العالمية للجودة.
`,
    service5: "الأمن",
    service5_p: `توفر (إكسبات كومباس)حماية أمنية شاملة للأفراد والأصول عبر دمج التواجد الميداني والتقنيات الذكية. نضمن تأميناً موثوقاً لعملياتكم استناداً إلى أكثر من ٤٠ عاماً من الخبرة والريادة في العراق.
`,
    view_pdf: "View Profile Catalog",
    
    s_top_header1: "الحيات بنل مصنع لإنتاج سندويج بنل",
    s_about_p:
      "معمل الحيات بنل لصناعة سندويج بنل ، هی احدی معامل محلية انشأت في سنة 2017 وبدأ بانتاج سندويج بنل (الواح عازلة ) منذ سنة 2018 بنوعيه السقفي و الجداري ، منتوجات معمل القوة تصنع بمكائن أوتوماتيكية و بجودة عالية و وفق معايير عالمية وحسب طلبيات . تهدف معمل القوة إلى تنمية و تطوير بنية التحتية لبلدنا و تأمين مواد بجودة عالية و محلية الصنع و زيادة اتاحة فرص عمل للمواطنين",
    s_whatspanel: "ما هو سندويج بنل؟",
    s_whatspanel_p:
      "سندويج بنل منتوج خفيف يتكون من ثلاث طبقات تمنحه ميزات و قدرات فائقة, يتمتع سندويج بنل بققاومة كبير للحرارة و عزال جديد للصوت و خفة وزنه و سهولة تركيبه. تتوسط الطبقة العازلة المصنوعة من مادة بولي يوريثين و بوليسترين بين طبقتين علوية و السفلية مصنوعة من الواح مضادة للصدا , تتسم هذه المواد العازلة بخصوص فيزيائية مميزة كمقاومتها للحرارة و الاشتعال و البرودة مما يقلل من تكاليف استخدام الطاقة",
    s_availables: "القياسات وسمك الالواح المنتج",
    s_specifics: "المميزات",
    s_spec_width: "العرض",
    s_spec_length: "الطول",
    s_spec_thikness: "سماكة",
    s_spec_density: "كثافة",
    s_spec_thermal: "توصيل حراري",
    s_spec_sound: "عزل الصوت",
    s_roof: "لوحة السقف",
    s_wall: "لوحة الجدار",
    s_f_1: "1000 مم",
    s_f_2: "18 م الأعلى",
    s_f_3: "50, 75, 100 مم",
    s_f_4: "40 کغم/م",
    s_f_4a: " (∓2)",
    s_f_5: "0.022 w/mk",
    s_f_6: "25 dB",
    s_application: "التطبيقات",
    s_application_p:
      "يمكن استخدام الالواح العازلة بشكل واسع في مجال البناء و الانشاءات مثل انشاء, المعارض , المطاعم , المسابيح , المدارس , الاسواق التجارية الكبيرة , قاعات حقول الدواجن و قاعة الاندية الرياضية و قاعات الطارات",
    s_type: "منتجات المعمل",
    s_type1: "سندويج بنل نوعية Rigid Polyurethane (PUR)",
    s_type2: "سندويج بنل نوعية Polyisocyanurate (PIR)",
    s_type3: "Sandwich Panel Ridges",
    s_specification: "مواصفات سندويج بنل",
    s_specific_1: "مقاوم للامطار و الابخرة",
    s_specific_2: "مقاوم للصداء",
    s_specific_3: "مقاوم للرياح والعواصف ",
    s_specific_4: "عدم التاثر باشعة الشمس",
    s_specific_5: "مقاوم للمواد الكيمياوية ",
    s_specific_6: "مقاوم للاشتعال ",
    s_specific_7: "عازل لدرجات الحرارة",
    s_specific_8: "عازل للصوت",
    s_specific_9: "مقوم للصدمات والهزات الارضية",
    s_specific_10: "مقاوم للحشرات",
    s_specific_11: "يتميز بمظهر جميل",
    s_specific_12: "حماية من التلوث البيئي",
    s_specific_13: "كلفة قليلة و السرعة في الانشاء",
    s_specific_14: "متوفر بالوان متعددة ",
    s_specific_15: "متانة عالية",
    s_specific_16: "يمكن اعادة استخدامة",
    s_add_value: "کركوك،طريق الحولي، قرب جسر ليلان",
    p_top_header1: " القوة بنل مصنع لإنتاج سندويج بنل",
    p_about_p:
      "معمل  القوة لصناعة سندويج بنل ، هی احدی معامل محلية انشأت في سنة 2017 وبدأ بانتاج سندويج بنل (الواح عازلة ) منذ سنة 2018 بنوعيه السقفي و الجداري ، منتوجات معمل القوة تصنع بمكائن أوتوماتيكية و بجودة عالية و وفق معايير عالمية وحسب طلبيات . تهدف معمل القوة إلى تنمية و تطوير بنية التحتية لبلدنا و تأمين مواد بجودة عالية و محلية الصنع و زيادة اتاحة فرص عمل للمواطنين",
    p_whatspanel: "ما هو سندويج بنل؟",
    p_whatspanel_p:
      "سندويج بنل منتوج خفيف يتكون من ثلاث طبقات تمنحه ميزات و قدرات فائقة, يتمتع سندويج بنل بققاومة كبير للحرارة و عزال جديد للصوت و خفة وزنه و سهولة تركيبه. تتوسط الطبقة العازلة المصنوعة من مادة بولي يوريثين و بوليسترين بين طبقتين علوية و السفلية مصنوعة من الواح مضادة للصدا , تتسم هذه المواد العازلة بخصوص فيزيائية مميزة كمقاومتها للحرارة و الاشتعال و البرودة مما يقلل من تكاليف استخدام الطاقة",
    p_availables: "القياسات وسمك الالواح المنتج",
    p_specifics: "المميزات",
    p_spec_width: "العرض",
    p_spec_length: "الطول",
    p_spec_thikness: "سماكة",
    p_spec_density: "كثافة",
    p_spec_thermal: "توصيل حراري",
    p_spec_sound: "عزل الصوت",
    p_roof: "لوحة السقف",
    p_wall: "لوحة الجدار",
    p_f_1: "1000 مم",
    p_f_2: "18 م الأعلى",
    p_f_3: "50, 75, 100 مم",
    p_f_4: "40 کغم/م",
    p_f_4a: " (∓2)",
    p_f_5: "0.022 w/mk",
    p_f_6: "25 dB",
    p_application: "التطبيقات",
    p_application_p:
      "يمكن استخدام الالواح العازلة بشكل واسع في مجال البناء و الانشاءات مثل انشاء, المعارض , المطاعم , المسابيح , المدارس , الاسواق التجارية الكبيرة , قاعات حقول الدواجن و قاعة الاندية الرياضية و قاعات الطارات",
    p_type: "منتجات المعمل",
    p_type1: "سندويج بنل نوعية Rigid Polyurethane (PUR)",
    p_type2: "سندويج بنل نوعية Polyisocyanurate (PIR)",
    p_type3: "Sandwich Panel Ridges",
    p_specification: "مواصفات سندويج بنل",
    p_specific_1: "مقاوم للامطار و الابخرة",
    p_specific_2: "مقاوم للصداء",
    p_specific_3: "مقاوم للرياح والعواصف ",
    p_specific_4: "عدم التاثر باشعة الشمس",
    p_specific_5: "مقاوم للمواد الكيمياوية ",
    p_specific_6: "مقاوم للاشتعال ",
    p_specific_7: "عازل لدرجات الحرارة",
    p_specific_8: "عازل للصوت",
    p_specific_9: "مقوم للصدمات والهزات الارضية",
    p_specific_10: "مقاوم للحشرات",
    p_specific_11: "يتميز بمظهر جميل",
    p_specific_12: "حماية من التلوث البيئي",
    p_specific_13: "كلفة قليلة و السرعة في الانشاء",
    p_specific_14: "متوفر بالوان متعددة ",
    p_specific_15: "High durability",
    p_specific_16: "Recyclable",
    p_add_value: "دهوك ، زاخو ، حسن ئافا ، خلف معرض السيارات",
    b_top_header1: "معمل بلاك بايب لإنتاج الأنابيب والمقاطع الحديدية",
    b_about_p: "يقوم مصنع بلاك بايب بإنتاج أفضل الأنابيب والمقاطع الحديدية بمختلف القياسات و بمعدات واجهزة جديدة ومتطورة، ووفق المعايير العراقية والدولية وبأيدي مهندسين ماهرين وذوي خبرة.تأسس مصنعنا في عام 2021 وفي وقت قصير بفضل منتجاته من حيث الجودة والكمية رسخت مكانتها في السوق.يهدف مصنعنا إلى الاكتفاء الذاتي والاعتماد على المهندسين والموظفين المحليين وتوفير أفضل أنواع المقاطع والأنابيب الحديدية، وتلبية الطلبات في وقت قصير حتى لا نحتاج إلى استيراد المنتجات الأجنبية.",
    b_type1: "أﻧﺎﺑﻴﺐ وﻣﻘﺎﻃﻊ اﻷﺳﻮد (حار)",
    b_type2: "أﻧﺎﺑﻴﺐ وﻣﻘﺎﻃﻊ حديد (بارد)",
    b_type3: "أﻧﺎﺑﻴﺐ وﻣﻘﺎﻃﻊ المغلونة",
    b_di1:"أنابیب مدورة",
    b_di2:"أنابیب مربعة",
    b_di3:"أنابیب مستطیلة",
    b_di4:"مقاطع",
     b_add_value: "العراق، أربيل، شارع گوير، قرب قرية قريتاغ",
     br_add_value: "الموقع: مدينة فلوجة – محافظة الأنبار – العراق",

     
    brabout_p:"يُعد معمل القنديل من أحدث المنشآت الصناعية في مدينة فلوجة، والمتخصصة في إنتاج مشبكات التسليح الملحومة كهربائياً (BRC). نعتمد في تصنيعنا على خطوط إنتاج أوتوماتيكية متطورة، ونستخدم خامات حديد عالية الجودة لنقدم لمنتسبي قطاع البناء والتشييد في العراق منتجاً يمتاز بالدقة العالية، ومطابقة للمواصفات القياسية العراقية والعالمية. نفتخر بأننا جزء من نهضة الإعمار في محافظة الأنبار والعراق عامة.",
    brdesc:"ما هي مشبكات التسليح BRC",
    brdesc_p:"شبكات حديدية ملحومة كهربائياً، تتكون من أسلاك طولية وعرضية متقاطعة بزوايا قائمة. تُستخدم كبديل مثالي عن حديد التسليح التقليدي (السيخ) في التطبيقات الخرسانية، حيث توفر وقت وجهد التنفيذ وتضمن توزيعاً دقيقاً للتسليح.",
    brad:"المزايا:",
    brad1:"سرعة التنفيذ: تغطية مساحات كبيرة في وقت قياسي.",
    brad2:"دقة الأبعاد: فتحات منتظمة وثابتة تضمن توزيعاً مثالياً للإجهادات.",
    brad3:"تقليل الفاقد: تُصنع بمقاسات محددة تقلل من بقايا الحديد.",
    brad4:"جودة اللحام: لحام كهربائي قوي يضمن ثبات الشبكة أثناء الصب.",
    brspe:"المواصفات الفنية للمنتجات",
    brspep:"ننتج في معمل القنديل تشكيلة واسعة تلبي كافة احتياجات المشاريع السكنية والصناعية والبنى التحتية.",
    feature:"Feature",
    specification:"Specification",
    ad:"القطر المتاح",
    ad1:"3.50 مم – 14 مم",
    od:"أبعاد الفتحات",
    od1:"من 100×100 مم إلى 250×250 مم",
    sd:"الأبعاد القياسية للوح",
    sd1:"2 × 6 متر (قابلة للتصنيع حسب الطلب)",
    ms:"شكل الشبكة",
    ms1:"مربعة أو مستطيلة حسب الرغبة",
    note_p:"ملاحظة: يتم تصنيع الألواح بأبعاد غير قياسية وفقاً لمتطلبات المشروع (أطوال تصل حسب طلب الزبون).",
    feilofap:"مجالات الاستخدام",
    foa1:"الأساسات: تسليح القواعد المسلحة، اللبشات، والأسطح الخرسانية.",
    foa2:"الأسقف: بديل فعال عن التسليح التقليدي في الأسقف المسطحة والكمرات الساقطة.",
    foa3:"الطرق والجسور: تسليح طبقات الرصف، الجسور الخرسانية، وممرات المشاة.",
    foa4:"العناصر الجاهزة: مصانع البلوك، البردورات، الأنابيب الخرسانية، والواح الحوائط.",
    foa5:`
(السياجات والأسوار: )يمكن توفير شبكات بفتحات وأقطار مناسبة للسياجات حسب الطلب.
`,
    brwhy:"لماذا معمل القنديل",
    brwhy1:"مرونة إنتاجية: تغطية كاملة لأقطار الأسلاك من 3.5 مم حتى 14 مم، وجميع أبعاد الفتحات المطلوبة.",
    brwhy2:"ألواح قياسية بطول 6 أمتار: تتيح تقليل عدد الوصلات وسرعة التنفيذ، مع إمكانية تصنيع أطوال خاصة.",
    brwhy3:"جودة عالية: استخدام حديد بليت مطابق للمواصفات، مع فحص دوري لشد الخضوع ومقاومة الشد وثبات اللحامات.",
    brwhy4:"تكنولوجيا حديثة: خطوط إنتاج أوتوماتيكية تعمل بالتحكم الرقمي للحام الكهربائي عالي الجودة.",
    brwhy5:"طاقة إنتاجية كبيرة: القدرة على تلبية طلبات المشاريع الكبيرة في وقت قياسي.",
    brwhy6:"خدمة التوصيل: أسطول من الشاحنات لتوصيل الطلبات إلى فلوجة وجميع المحافظات .",
    quality:"الجودة والمواصفات",
    quality_p:`مطابق للمواصفة القياسية العراقية (IQS) والمعايير الدولية ذات الصلة.
يتم إجراء اختبارات دورية في مختبرات معتمدة لضمان مطابقة اللحامات والأبعاد والخصائص الميكانيكية.
`,
br_top_header1:"معمل  القنديل لتصنيع شبك الحديد",

smabout_p:"في مدينة عامرية الصمود، تأسس مصنع الصمود ليكون صرحًا صناعيًا رائدًا في مجال إنتاج الأنابيب والمقاطع الحديدية. نعتمد على أحدث خطوط الإنتاج لتوفير منتجات عالية الجودة تلبي متطلبات السوق المحلي والدولي، مع الالتزام بأعلى معايير الدقة الهندسية والجودة.",
    sm_vision:"رؤيتنا ",
    sm_vision_p:"أن نكون الرائد الإقليمي الأول في صناعة الأنابيب والمقاطع الحديدية، مساهمين في بناء مستقبل عمراني وصناعي صلب، من خلال تقديم منتجات تجمع بين المتانة الفائقة والدقة الهندسية المتناهية.",
    sm_mission:"رسالتنا",
    sm_mission_p:"التزامنا في مصنع الصمود هو تزويد عملائنا بحلول فولاذية عالية الجودة تتوافق مع المعايير العالمية، مع التركيز على الابتكار في التصنيع ومرونة الإنتاج لتلبية كافة احتياجات المشاريع الإنشائية والصناعية بدقة وموثوقية.",
    corvlaue:"قيمنا الجوهرية ",
    cor1:"الصمود: صلابة المنتج في أصعب الظروف.",
    cor2:"الدقة: التزام تام بالقياسات والمواصفات الفنية.",
    cor3:"الشراكة: نحن شركاء نجاح لعملائنا في كل مشروع.",
    cor4:"التطوير: السعي المستمر لتحديث خطوط الإنتاج وتقنيات التصنيع.",
    qua:"الجودة والمعايير الفنية ",
    qua_p:"في مصنع الصمود، الجودة ليست مجرد شعار، بل هي عملية متكاملة تبدأ من اختيار المواد الخام (الملفات الحديدية) وتنتهي باختبار المنتج النهائي. نحن نلتزم بأعلى معايير التصنيع لضمان دقة الأبعاد وثبات السماكة في كل قطعة تخرج من مصنعنا في عامرية الصمود.",
    comit:"التزامنا بالمعايير",
    comit_p:"o	المواصفات القياسية العراقية (IQS): كافة منتجاتنا من الأنابيب والمقاطع الحديدية مصنعة لتطابق المواصفات القياسية العراقية المعتمدة للجودة والمتانة.",
    chs:"قسم الأنابيب الدائرية ",
    dimen:"تفاصيل القياس والسماكة:",
    or:"المدى العام",
    or1:"من 15.88 ملم إلى 219 ملم",
    sm:"الصغيرة ",
    sm1:"(15.88 - 50.8 ملم): تبدأ السماكة من 0.60 ملم",
    md:"المتوسطة ",
    md1:"(101 - 114 ملم): تبدأ السماكة من 1.50 ملم",
    lg:"الكبيرة",
    lg1:"(حتى 219 ملم): تبدأ السماكة من 2.50 ملم",
    shs:"قسم المقاطع المربعة  ",
    or2:"من 15×15 ملم إلى 175×175 ملم",
    sm2:"(15×15 - 40×40 ملم): تبدأ السماكة من 0.60 ملم",
    md2:"(90×90 - 100×100 ملم): تبدأ السماكة من 1.50 ملم",
    lg2:"(حتى 175×175 ملم): تبدأ السماكة من 2.50 ملم",
    rhs:"قسم المقاطع المستطيلة  ",
    or3:"من 10×15 ملم إلى 150×200 ملم",
    sm3:"(10×15 - 30×50 ملم): تبدأ السماكة من 0.60 ملم",
    md3:"(50×100 - 75×150 ملم): تبدأ السماكة من 1.50 ملم",
    lg3:"(حتى 150×200 ملم): تبدأ السماكة من 2.50 ملم",
    cs:"الأطوال المخصصة والطلبات الخاصة  ",
    sl:"الطول القياسي: 6 متر.",
    cl:"الأطوال المخصصة: إمكانية الإنتاج حسب الطلب من 3 متر وحتى 12 متر.",
    product:"تطبيقات واستخدامات المنتجات ",
    product_p:"تتميز أنابيب ومقاطع مصنع الصمود بتعدد استخداماتها بفضل دقتها العالية ومتانتها، مما يجعلها الخيار الأمثل لمجموعة واسعة من القطاعات الصناعية والإنشائية، ومنها:",
    pro1:"الإنشاءات والمباني: صناعة الأبواب، الشبابيك، والهياكل الحديدية للمباني والمستودعات.",
    pro2:"الصناعات المعدنية: تشكيل الهياكل المعدنية المعقدة والمنصات.",
    pro3:"صناعة الأثاث: الهياكل المعدنية للأثاث المنزلي والمكتبي الحديث.",
    pro4:"القطاع الزراعي: تصميم أنظمة الري والرش المحوري، وبناء الهياكل الخاصة بالبيوت البلاستيكية (البيوت المحمية).",
    pro5:"البنية التحتية: هندسة الحواجز، السياج الأمني، وأعمدة الإنارة.",
     sm_top_header1: "معمل الصمود لإنتاج الأنابيب والمقاطع الحديدية",
     sm_add_value:"عراق، محافظة الأنبار، عامرية الفلوجة، مجمع الصمود الصناعي",

     "rs_slogan": "راو ستيل: الرواد في إنتاج ألواح الحديد المغلّف والمطلي على مستوى العراق وكردستان.",
    "rs_about_title": "من نحن",
    "rs_about_desc1": "تعتبر شركة 'راو ستيل' مشروعاً صناعياً استراتيجياً وفريداً من نوعه على مستوى العراق وإقليم كردستان، وهو متخصص في صناعات طلاء، وتلوين، وجلفنة ألواح ولفائف الحديد والصلب. يتم تشييد مصنعنا في محافظة أربيل على مساحة إجمالية تبلغ 84,000 متر مربع، تم تخصيص أكثر من 32% منها للمساحات الخضراء التزاماً منا بحماية البيئة وتحقيق الاستدامة.",
    "rs_about_desc2": "نحن نهدف، من خلال توظيف أحدث التكنولوجيات العالمية وخطوط الإنتاج المتقدمة، إلى توفير منتجات ذات جودة عالية قادرة على منافسة المنتجات العالمية. يشكل مشروعنا ركيزة أساسية لدعم القطاعين العام والخاص، ويلعب دوراً محورياً في الحد من الاستيراد الخارجي، بالإضافة إلى توفير فرص عمل مباشرة وغير مباشرة للشباب الواعد في بلدنا.",
    "rs_vision_title": "الرؤية",
    "rs_vision_desc": "أن نصبح المصدر الأكبر والأكثر موثوقية لتوريد لفائف الحديد المغلّفة والمطلية في جميع أنحاء العراق والشرق الأوسط.",
    "rs_mission_title": "الرسالة",
    "rs_mission_desc": "تقديم منتجات حديد وصلب وفق أعلى المعايير والمواصفات العالمية، تتميز بمقاومتها الفائقة للظروف الجوية والصدأ والتآكل، وبأسعار تنافسية ومناسبة، مع الالتزام التام بالمسؤولية المجتمعية والبيئية.",
    "rs_products_title": "القدرة الإنتاجية ومنتجاتنا",
    "rs_products_desc": "من المقرر أن يعمل مشروعنا بطاقة إنتاجية ضخمة تصل إلى 20,000 طن شهرياً، وتتمثل منتجاتنا الرئيسية في:",
    "rs_prod1_title": "لفائف الحديد المطلي",
    "rs_prod1_desc": "بطاقة إنتاجية تبلغ 8,000 طن شهرياً، حيث تُستخدم أصباغ عالية الجودة ومقاومة للصدأ لتلبية متطلبات السوق ومختلف الألوان المطلوبة.",
    "rs_prod2_title": "لفائف الحديد المغلّف",
    "rs_prod2_desc": "بطاقة إنتاجية تبلغ 12,000 طن شهرياً، وتتم معالجتها بطبقات من الزنك أو الكروم لمقاومة الرطوبة، الأمطار، والتآكل، مما يضمن إطالة العمر الافتراضي للحديد.",
    "rs_target_sectors_title": "القطاعات المستفيدة من منتجاتنا:",
    "rs_sector1": "مصانع إنتاج الساندويتش بانل.",
    "rs_sector2": "مصانع تصنيع خزانات المياه، أعمدة الكهرباء، وأبراج الاتصالات.",
    "rs_sector3": "صناعات الأجهزة المنزلية والكهربائية (الثلاجات، المجمّدات، الغسالات، الطاولات والرفوف المعدنية).",
    "rs_sector4": "شركات المقاولات، البناء، وتصنيع الهياكل والجسور الحديدية.",
    "rs_process_title": "مراحل الإنتاج",
    "rs_process_desc": "نعتمد في مصنعنا نظام تشغيل منظم ومستمر على مدار 24 ساعة من خلال ثلاثة مناوبات عمل:",
    "rs_step1_title": "شراء المواد الخام",
    "rs_step1_desc": "استيراد لفائف الحديد الأسود (الملفوف على الساخن/البارد) من أفضل المصادر العالمية (مثل الصين).",
    "rs_step2_title": "بسط اللفائف",
    "rs_step2_desc": "ربط وتغذية اللفائف بشكل مستمر لضمان عدم توقف خط الإنتاج.",
    "rs_step3_title": "التنظيف والمعالجة السطحية",
    "rs_step3_desc": "غسل وتنظيف الحديد من الشوائب والمخلفات باستخدام الفوسفات ومحاليل غسيل صناعية خاصة.",
    "rs_step4_title": "التسخين الحراري",
    "rs_step4_desc": "تهيئة المعدن حرارياً لضمان الالتصاق التام للأصباغ أو طبقة الزنك.",
    "rs_step5_title": "الطلاء أو الجلفنة",
    "rs_step5_desc": "تطبيق عملية الطلاء السطحي أو الجلفنة بالغمس الساخن بدقة عالية.",
    "rs_step6_title": "التجفيف",
    "rs_step6_desc": "استخدام أفران صناعية متطورة للتجفيف السريع والمتجانس.",
    "rs_step7_title": "إعادة اللف والتغليف",
    "rs_step7_desc": "التغليف الصناعي النهائي لإعداد المنتج للتخزين والتوزيع في الأسواق.",
    "rs_env_title": "الالتزام البيئي والمجتمعي",
    "rs_env_sub1": "حماية البيئة",
    "rs_env_desc1": "يضم مصنعنا وحدة متكاملة لمعالجة المياه الصناعية المستعملة بالإضافة إلى منظومة فلاتر متطورة لمنع انبعاث الغازات الضارة.",
    "rs_env_sub2": "خلق فرص العمل",
    "rs_env_desc2": "يوفر المشروع في مرحلة التنفيذ والإنشاء أكثر من 750 فرصة عمل، وفي مرحلة التشغيل الفعلي يضم أكثر من 80 موظفاً دائمياً من الكوادر الإدارية والفنية المتخصصة.",
    "rs_swot_title": "نقاط قوتنا",
    "rs_swot1_title": "مشروع ريادي فريد",
    "rs_swot1_desc": "يعد المصنع الأول والأكبر من نوعه في المنطقة بهذه القدرات التكنولوجية.",
    "rs_swot2_title": "جودة عالمية",
    "rs_swot2_desc": "نهدف إلى المنافسة المباشرة وإحلال الواردات القادمة من تركيا وإيران.",
    "rs_swot3_title": "التطوير المستمر",
    "rs_swot3_desc": "تخضع كوادرنا الهندسية والفنية لدورات تدريبية مكثفة ومستمرة لمواكبة أحدث تكنولوجيات التصنيع العالمية.",
    "rs_address_value": "العراق، إقليم كردستان، محافظة أربيل."
 
  },
};
